export default __webpack_public_path__ + "static/media/Fleming College.jpg.9e47a5c9.png";